import * as React from 'react';
import { Link } from 'gatsby';

import { isNotSSR } from '@utils';

import { ReactComponent as Logo } from '../../assets/icons/orange-logo.svg';
import { ReactComponent as Plus } from '../../assets/icons/plus.svg';
import { ScContainer } from '../container/styled';
import { firstLinksRow } from '../footer/helpers';
import { ScMobileFooterTitle } from '../footer/styled';
import { Index } from '../navigation-accordion';

import {
	ScMobileHeaderGroups,
	ScSidebarContent,
	ScSidebarHeaderWrapper,
	ScSidebarLogos,
	ScSidebarWrapper,
} from './styled';

export const Sidebar = ({
	isOpen,
	sidebarHandler,
}: {
	isOpen: boolean;
	sidebarHandler: (itemType?: string) => void;
}) => {
	return (
		<ScSidebarWrapper isOpen={isOpen}>
			<ScContainer>
				<ScSidebarContent>
					<ScSidebarHeaderWrapper>
						<Link to={'/'}>
							<Logo />
						</Link>
            <Plus className="close" onClick={() => { sidebarHandler() }} />
          </ScSidebarHeaderWrapper>
					<ScMobileHeaderGroups>
						{firstLinksRow.map((item) => (
							<Index item={item} key={item.title} openModal={sidebarHandler} />
						))}
						<ScMobileFooterTitle
							className="clickable-footer-link"
							onClick={() => {
								isNotSSR && window.open('https://www.linkedin.com/company/gogetabenefits/home/');
							}}
						>
							Linkedin
						</ScMobileFooterTitle>
					</ScMobileHeaderGroups>
				</ScSidebarContent>
			</ScContainer>
			<ScSidebarLogos />
		</ScSidebarWrapper>
	);
};
